import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import HandymanOutlinedIcon from "@mui/icons-material/HandymanOutlined";
import PaymentOutlinedIcon from "@mui/icons-material/PaymentOutlined";
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";

import { TRACKING_CARD_ORANGE_SX } from "./trackingStyles";

const taskIcon = (task) => {
  if (task.fieldKey === "contractorSelector") return <HandymanOutlinedIcon />;
  if (task.fieldKey === "paymentSelector") return <PaymentOutlinedIcon />;
  if (task.type === "upload" || task.type === "file") return <CloudUploadOutlinedIcon />;
  return <AssignmentOutlinedIcon />;
};

const RequestActionCenter = ({ tasks, onTaskAction, onScrollToForm }) => {
  if (!tasks?.length) return null;

  const countLabel = `${tasks.length.toLocaleString("fa-IR")} مورد`;

  return (
    <Box sx={{ ...TRACKING_CARD_ORANGE_SX, p: { xs: 2, md: 2.5 } }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        gap={1}
        sx={{ mb: 2 }}
      >
        <Typography variant="subtitle1" fontWeight={800} color="#E65100">
          اقدام مورد نیاز شما
        </Typography>
        <Chip label={countLabel} size="small" color="warning" sx={{ fontWeight: 700 }} />
      </Stack>

      <Grid container spacing={1.5}>
        {tasks.map((task) => (
          <Grid item xs={12} md={6} key={task.id}>
            <Card
              variant="outlined"
              sx={{
                borderRadius: 2,
                borderColor: "#FFE0B2",
                height: "100%",
              }}
            >
              <CardContent sx={{ py: 1.5, "&:last-child": { pb: 1.5 } }}>
                <Stack spacing={1.25}>
                  <Stack direction="row" spacing={1.25} alignItems="flex-start">
                    <Box
                      sx={{
                        p: 1,
                        borderRadius: 2,
                        bgcolor: "#FFF3E0",
                        color: "#F57C00",
                        display: "flex",
                      }}
                    >
                      {taskIcon(task)}
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Stack
                        direction="row"
                        alignItems="center"
                        spacing={1}
                        flexWrap="wrap"
                        sx={{ mb: 0.5 }}
                      >
                        <Typography variant="subtitle2" fontWeight={700}>
                          {task.title}
                        </Typography>
                        <Chip
                          label={task.urgencyLabel}
                          size="small"
                          color={task.urgency === "urgent" ? "error" : "warning"}
                          variant={task.urgency === "urgent" ? "filled" : "outlined"}
                        />
                      </Stack>
                      <Typography variant="body2" color="text.secondary" lineHeight={1.55}>
                        {task.description}
                      </Typography>
                    </Box>
                  </Stack>
                  <Button
                    variant="contained"
                    size="small"
                    fullWidth
                    endIcon={<ArrowBackIcon sx={{ transform: "scaleX(-1)" }} />}
                    onClick={() => {
                      onTaskAction?.(task);
                      onScrollToForm?.();
                    }}
                    sx={{
                      bgcolor: "#F57C00",
                      "&:hover": { bgcolor: "#EF6C00" },
                      borderRadius: 2,
                      fontWeight: 700,
                    }}
                  >
                    {task.actionLabel}
                  </Button>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

RequestActionCenter.propTypes = {
  tasks: PropTypes.array,
  onTaskAction: PropTypes.func,
  onScrollToForm: PropTypes.func,
};

export default RequestActionCenter;
